export default {
  cancel: 'Cancel',
  collapse_expand: 'Collapse/Expand',
  collapsed: 'Collapsed',
  completed_attack: 'Completed Test',
  concurrent_node: 'Concurrent Node',
  confirm: 'Confirm',
  continue: 'Continue',
  clone: 'Clone'
}
